import type { FaireProductEntity } from "../../entity_types/product";

export const p_95mmhg9pc2: FaireProductEntity = {
  token: "p_95mmhg9pc2",
  type: "product",
  name: "Mahjong tiles coaster set, custom set of 4",
  brandToken: "b_c2gb76mv7f",
  brandName: "Crafty Vintage Games",
  imageUrl:
    "https://cdn.faire.com/fastly/372c76af6b90891e3caac6045414b9e0db1335a66b987d3ccdb9af2fb4124d20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d31408f59e9bd57d7a00db238ba3eeb3650aa470391e022fcd12622adccb552c.jpeg",
    "https://cdn.faire.com/fastly/e2dc821a7b70b1243b234dda929d727080a52f1929b70d55f427c2d3309ee233.jpeg",
    "https://cdn.faire.com/fastly/df8777f1194e044517b2d4df848cc0acc12eafaeedd1ada318aa4320448cf653.jpeg",
    "https://cdn.faire.com/fastly/cf2681895e682565781ce7dc0e1246d64e09127690a99445aa7bf567f4b203e7.jpeg",
    "https://cdn.faire.com/fastly/d8330da99755b8aa0ed45c91dd2df4fa08ff18a44db389ea0f0974d5003537c6.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "These coasters are available in sets of 4 and measure 2.75” by 3”. The travel size Mahjong tiles are randomly selected, and each coaster is different. The tiles are secured together and glued to a cork bottom that has been sprayed with a water protective sealer to guard against water stains on your table. Each coaster has been sealed for years of use. These coasters work beautifully as unique game night decorations that spark conversation, thoughtful gifts for mahjong club members, cultural celebration pieces for Asian heritage families, creative additions to game room holiday decor, and memorable keepsakes for gaming enthusiasts. The durable construction ensures these coasters will be a favorite for years to come, making them both a festive decoration and a meaningful gift that celebrates the recipient's love for this timeless game.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:39.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
